import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/survey',
        name: 'Survey',
        component: () => import('./views/Survey.vue'),
    },
    {
        path: '/home/:id?/:hashKey?',
        name: 'Home',
        component: () => import('./views/Home.vue'),
    },
    {
        path: '/about-us',
        name: 'About',
        component: () => import('./views/About.vue'),
    },
    {
        path: '/survey-finished',
        name: 'SurveyFinished',
        component: () => import('./views/SurveyFinished.vue'),
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('./views/NotFound.vue'),
    },
    {
        path: '*',
        redirect: '/home',
        component: () => import('./views/NotFound.vue'),
    }
];

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});